import React, { useState } from 'react';
import styles from './AllItemsPage.module.scss';
import { Loader, Select, Tabs } from 'tt-ui-lib/core';
import { Table } from './Components/Table';

const AllItemsPage = () => {
  const pageSize = 9;
  const [tableData, setTableData] = useState([]);
  const [isFetchTable, setIsFetchTable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sections, setSections] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [filter, setFilter] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [loadingSections, setLoadingSections] = useState(false);
  const [queryFilter, setQueryFilter] = useState({
    limit: pageSize,
    page: currentPage,
    order_dir: 'desc',
    f: '',
    is_active: '',
  });

  const [selectedSection, setSelectedSection] = useState(0);
  const [selectedBlock, setSelectedBlock] = useState(0);

  const handleChangeSection = (newValue) => {
    // if (isAddQuestion) {
    //   setOpenAddCloseConfirm(true);
    //   setNewAddConfirmSectionValue(newValue);
    //   return;
    // }

    setSelectedSection(newValue);
    setSelectedBlock(0);
    setCurrentPage(1);
    setFilter({ f: '' });
  };

  const handleChangeBlock = (newValue) => {
    // if (isAddQuestion || isEditQuestion) {
    //   setOpenAddCloseConfirm(true);
    //   setNewAddConfirmValue(newValue);
    //   return;
    // }

    setSelectedBlock(newValue);
    setCurrentPage(1);
    setFilter({ f: '' });
  };

  const handleChangeSectionSelect = (value) => {
    handleChangeSection(value);
  };

  const handleChangeBlockSelect = (value) => {
    handleChangeBlock(value);
  };

  return (
    <>
      <div className={styles.pageContainer}>
        {sections.length > 0 ? (
          <Tabs
            selectedTab={selectedSection}
            onChangeTab={handleChangeSection}
            selectedChildTab={selectedBlock}
            onChangeChildTab={handleChangeBlock}
            tabs={sections.map((item) => ({
              name: item.name,
              id: item.id,
              child: blocks.map((block) => ({
                name: block.name,
                id: block.id,
              })),
            }))}
          />
        ) : null}

        {sections.length > 0 ? (
          <div>
            <Select
              onChange={handleChangeSectionSelect}
              value={selectedSection}
              className={styles.topSelect}
              options={sections.map((item) => ({
                label: item.name,
                value: item.id,
              }))}
            />

            <Select
              onChange={handleChangeBlockSelect}
              value={selectedBlock}
              className={styles.topSelect}
              options={blocks.map((item) => ({
                label: item.name,
                value: item.id,
              }))}
            />
          </div>
        ) : null}

        {sections.length > 0 ? (
          <Table
            tableData={tableData}
            pages={pages}
            loading={loading}
            queryFilter={queryFilter}
            setQueryFilter={setQueryFilter}
            // setOpenEditBlock={setOpenEditBlock}
            // setNameEditBlock={setNameEditBlock}
            // setIdEditBlock={setIdEditBlock}
            filter={filter}
            setFilter={setFilter}
            setCurrentPage={setCurrentPage}
            selectedBlock={selectedBlock}
            // setIsAddBlock={setIsAddQuestion}
            pageSize={pageSize}
            currentPage={currentPage}
            allBlocks={blocks}
            // setIsEditQuestion={setIsEditQuestion}
            // setIdEditQuestion={setIdEditQuestion}
            reloadTableMethod={() => {
              setIsFetchTable(true);
            }}
          />
        ) : loadingSections ? (
          <div className={styles.emptyContainer}>
            <Loader />
          </div>
        ) : (
          <div className={styles.emptyContainer}>No data yet...</div>
        )}
      </div>
    </>
  );
};

export default AllItemsPage;
